import { StyledPageContainer } from '../styles';
import { useEffect, useState, VFC } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Link } from 'react-router-dom';
import { breakpoints } from '../../styles/variables/breakpoints';
import { colors } from '../../styles/variables/colors';

export const StyledMenu = styled.div`
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  background-color: ${colors.white};
  z-index: 200;
`;

export const StyledMenuContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 95px;
`;

export const StyledItems = styled.div<{ active?: boolean }>`
  display: flex;
  justify-content: center;
  cursor: pointer;

  @media ${breakpoints.width768} {
    display: none;

    ${({ active }) =>
      active &&
      css`
        position: fixed;
        z-index: 50;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding-top: 50px;
        align-items: center;
        width: 100%;
        top: 95px;
        left: 0;
        height: calc(100% - 95px);
        background-color: ${colors.white};
      `}
  }
`;

export const StyledBurger = styled.div<{ active?: boolean }>`
  display: none;
  width: 28px;
  height: 21px;

  @media ${breakpoints.width768} {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  & > div {
    width: 100%;
    height: 3px;
    background-color: ${colors.black};
    transition: all 200ms;

    &:nth-child(1) {
      transform-origin: top right;
    }
    &:nth-child(3) {
      transform-origin: bottom right;
    }

    ${({ active }) =>
      active &&
      css`
        &:nth-child(1) {
          transform: rotate(-45deg);
        }
        &:nth-child(2) {
          opacity: 0;
        }
        &:nth-child(3) {
          transform: rotate(45deg);
        }
      `}
  }
`;

export const StyledItemLink = styled(Link)<{ active?: boolean }>`
  margin-right: 30px;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 400;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: ${colors.black};

  @media ${breakpoints.width992} {
    margin-right: 25px;
    font-size: 12px;
  }

  @media ${breakpoints.width768} {
    margin-right: 0;
    margin-bottom: 20px;
    font-size: 14px;
  }

  ${({ active }) =>
    active &&
    css`
      font-weight: bold;
    `}

  &:last-child {
    margin-right: 0;
  }
`;

export const Menu: VFC = () => {
  useEffect(() => {
    // TODO: API test
  }, []);

  const [navOpen, setNavOpen] = useState(false);

  const toggleNav = () => {
    setNavOpen(!navOpen);
    window.scrollTo(0, 0);
  };

  return (
    <StyledMenu>
      <StyledPageContainer>
        <StyledMenuContent>
          <Link to="/" onClick={toggleNav}>
            <img
              src={process.env.PUBLIC_URL + '/logo.svg'}
              style={{ width: 200 }}
            />
          </Link>
          <StyledItems active={navOpen}>
            <StyledItemLink
              to="/"
              onClick={toggleNav}
              style={{
                textDecoration: 'none',
                color: 'black',
              }}
            >
              Vyhledávání
            </StyledItemLink>
            <StyledItemLink
              to="/list"
              onClick={toggleNav}
              style={{
                textDecoration: 'none',
                color: 'black',
              }}
            >
              Seznam hlasování
            </StyledItemLink>
            <StyledItemLink
              to="/absence"
              onClick={toggleNav}
              style={{
                textDecoration: 'none',
                color: 'black',
              }}
            >
              Absence a prezence
            </StyledItemLink>
            <StyledItemLink
              to="/about"
              onClick={toggleNav}
              style={{
                textDecoration: 'none',
                color: 'black',
              }}
            >
              O projektu
            </StyledItemLink>
          </StyledItems>
          <StyledBurger active={navOpen} onClick={toggleNav}>
            <div></div>
            <div></div>
            <div></div>
          </StyledBurger>
        </StyledMenuContent>
      </StyledPageContainer>
    </StyledMenu>
  );
};
